import { createReducer, on } from '@ngrx/store';
import { setListFilters } from '../actions/filters-list.actions';
import { FilterStatsListState } from '../states/stats-list.state';

export const initialState: FilterStatsListState = {
  listFilter: undefined,
};

export const StatsListReducers = createReducer(
  initialState,
  on(setListFilters, (state, { listFilters }) => {
    return { ...state, listFilter: listFilters };
  })
);
